export default "__VITE_ASSET__8w82vpe1__"